import React, { useState } from "react";
import { BiChevronLeft, BiChevronRight } from "react-icons/bi";
import { fetchGet } from "../../fetchers";

const thClass =
  "font-bold px-4 py-3 align-middle border-b-2 border-solid border-blue-900 whitespace-nowrap text-left text-base";
const tdClass =
  "border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-4 py-2 text-left";

const getStockStatus = (saldoAkhir, minQty) => {
  const selisih = (parseFloat(saldoAkhir) || 0) - (parseFloat(minQty) || 0);
  if (selisih <= 0) return { status: "danger", text: "Segera PO" };
  return { status: "safe", text: "Stock Tersedia" };
};

// Saldo Akhir yang ditampilkan = Saldo Akhir pembukuan + Transit Out (barang yang sudah
// dipotong dari stok tapi pengeluarannya belum di-Approve). Dibulatkan 4 desimal agar
// penjumlahan float tak menghasilkan ekor seperti 12.000000000001.
export const saldoAkhirTampil = (row) =>
  Math.round(((parseFloat(row?.SaldoAkhir) || 0) + (parseFloat(row?.QtyTransitOut) || 0)) * 10000) / 10000;

const TableStock = ({
  data = [],
  onDetail,
  isLoading,
  onPageChange,
  onPerRowsChange,
  totalRows,
  currentPage,
  perPage,
  showAll,
  bisnisUnit,
  periode,
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [modalData, setModalData] = useState([]);
  const [modalBarang, setModalBarang] = useState({ BarangID: "", NamaBarang: "" });

  const [penerimaanModalOpen, setPenerimaanModalOpen] = useState(false);
  const [penerimaanModalLoading, setPenerimaanModalLoading] = useState(false);
  const [penerimaanModalData, setPenerimaanModalData] = useState([]);
  const [penerimaanModalBarang, setPenerimaanModalBarang] = useState({ BarangID: "", NamaBarang: "" });

  const [belumModalOpen, setBelumModalOpen] = useState(false);
  const [belumModalLoading, setBelumModalLoading] = useState(false);
  const [belumModalData, setBelumModalData] = useState([]);
  const [belumModalBarang, setBelumModalBarang] = useState({ BarangID: "", NamaBarang: "" });

  const [outModalOpen, setOutModalOpen] = useState(false);
  const [outModalLoading, setOutModalLoading] = useState(false);
  const [outModalData, setOutModalData] = useState([]);
  const [outModalBarang, setOutModalBarang] = useState({ BarangID: "", NamaBarang: "" });

  // Komposisi Saldo Akhir (klik angka Saldo Akhir).
  const [saldoModalOpen, setSaldoModalOpen] = useState(false);
  const [saldoModalLoading, setSaldoModalLoading] = useState(false);
  const [saldoModalData, setSaldoModalData] = useState([]);
  const [saldoModalRow, setSaldoModalRow] = useState(null);

  const fetchTransitOut = async (barangID) => {
    const bulan = showAll ? "all" : periode.bulan;
    const tahun = showAll ? "all" : periode.tahun;
    const res = await fetchGet(`Procurement/GoodsStockTransitOut/${bisnisUnit}/${bulan}/${tahun}/${barangID}`);
    return Array.isArray(res?.data) ? res.data : Array.isArray(res) ? res : [];
  };

  // Transit Out: GE yang sudah dikirim ke approval (stok sudah terpotong) tapi belum di-Approve.
  const handleTransitOutClick = async (e, row) => {
    e.stopPropagation();
    if (!row.QtyTransitOut || parseFloat(row.QtyTransitOut) === 0) return;

    setOutModalBarang({ BarangID: row.BarangID, NamaBarang: row.NamaBarang });
    setOutModalOpen(true);
    setOutModalLoading(true);
    setOutModalData([]);
    try {
      setOutModalData(await fetchTransitOut(row.BarangID));
    } catch {
      setOutModalData([]);
    } finally {
      setOutModalLoading(false);
    }
  };

  const handleSaldoAkhirClick = async (e, row) => {
    e.stopPropagation();
    setSaldoModalRow(row);
    setSaldoModalOpen(true);
    setSaldoModalData([]);
    if (!row.QtyTransitOut || parseFloat(row.QtyTransitOut) === 0) {
      setSaldoModalLoading(false);
      return;
    }
    setSaldoModalLoading(true);
    try {
      setSaldoModalData(await fetchTransitOut(row.BarangID));
    } catch {
      setSaldoModalData([]);
    } finally {
      setSaldoModalLoading(false);
    }
  };

  const handlePengeluaranClick = async (e, row) => {
    e.stopPropagation();
    if (!row.Pengeluaraan || parseFloat(row.Pengeluaraan) === 0) return;
    if (showAll) return;

    setModalBarang({ BarangID: row.BarangID, NamaBarang: row.NamaBarang });
    setModalOpen(true);
    setModalLoading(true);
    setModalData([]);

    try {
      const res = await fetchGet(
        `Procurement/GoodsExpenditure/lap/${bisnisUnit}/${periode.bulan}/${periode.tahun}/${row.BarangID}`
      );
      // Kolom Pengeluaran = hanya yang sudah di-Approve; yang menunggu approval ada di Transit Out.
      const semua = Array.isArray(res?.data) ? res.data : Array.isArray(res) ? res : [];
      setModalData(semua.filter((d) => d.Status === "Approved"));
    } catch {
      setModalData([]);
    } finally {
      setModalLoading(false);
    }
  };

  const handlePenerimaanClick = async (e, row) => {
    e.stopPropagation();
    if (!row.Penerimaan || parseFloat(row.Penerimaan) === 0) return;
    if (showAll) return;

    setPenerimaanModalBarang({ BarangID: row.BarangID, NamaBarang: row.NamaBarang });
    setPenerimaanModalOpen(true);
    setPenerimaanModalLoading(true);
    setPenerimaanModalData([]);

    try {
      const res = await fetchGet(
        `Procurement/GoodsAcceptance/lap/${bisnisUnit}/${periode.bulan}/${periode.tahun}/${row.BarangID}`
      );
      setPenerimaanModalData(Array.isArray(res?.data) ? res.data : Array.isArray(res) ? res : []);
    } catch {
      setPenerimaanModalData([]);
    } finally {
      setPenerimaanModalLoading(false);
    }
  };

  // Sisa PO yang belum diterima: posisi per akhir periode yang tampil; mode "semua"
  // (tanpa periode) memakai posisi terkini (backend membaca "all" sebagai tanpa batas).
  const handleBelumDiterimaClick = async (e, row) => {
    e.stopPropagation();
    if (!row.QtyBelumDiterima || parseFloat(row.QtyBelumDiterima) === 0) return;

    setBelumModalBarang({ BarangID: row.BarangID, NamaBarang: row.NamaBarang });
    setBelumModalOpen(true);
    setBelumModalLoading(true);
    setBelumModalData([]);

    const bulan = showAll ? "all" : periode.bulan;
    const tahun = showAll ? "all" : periode.tahun;
    try {
      const res = await fetchGet(
        `Procurement/GoodsStockBelumDiterima/${bisnisUnit}/${bulan}/${tahun}/${row.BarangID}`
      );
      setBelumModalData(Array.isArray(res?.data) ? res.data : Array.isArray(res) ? res : []);
    } catch {
      setBelumModalData([]);
    } finally {
      setBelumModalLoading(false);
    }
  };

  const totalPages = Math.ceil(totalRows / perPage);
  const rowOptions = [10, 25, 50, 100, -1];

  const formattedData = data.map((item, index) => ({
    ...item,
    no: (currentPage - 1) * perPage + index + 1,
  }));

  const totalQtyKeluar = modalData.filter((d) => d.Status !== "Ditolak").reduce((sum, d) => sum + (parseFloat(d.QtyKeluar) || 0), 0);

  return (
    <div>
      {/* Table */}
      <div className="overflow-x-auto">
        <table className="table-auto w-full bg-transparent border-collapse text-sm">
          <thead>
            <tr style={{ backgroundColor: "#1e3a5f" }}>
              <th className={thClass} style={{ color: "#fb923c" }}>No</th>
              <th className={thClass} style={{ color: "#fb923c" }}>Barang ID</th>
              <th className={thClass} style={{ color: "#fb923c" }}>Kode Stock</th>
              <th className={thClass} style={{ color: "#fb923c" }}>Nama Barang</th>
              <th className={thClass} style={{ color: "#fb923c" }}>Satuan</th>
              <th className={thClass + " text-right"} style={{ color: "#fb923c" }}>Min Qty</th>
              <th className={thClass + " text-right"} style={{ color: "#fb923c" }}>Saldo Awal</th>
              <th className={thClass + " text-right"} style={{ color: "#fb923c" }}>Saldo Awal Nominal</th>
              <th className={thClass + " text-right"} style={{ color: "#fb923c" }}>Penerimaan</th>
              <th className={thClass + " text-right"} style={{ color: "#fb923c" }}>Penerimaan Nominal</th>
              <th className={thClass + " text-right"} style={{ color: "#fb923c" }}>Tersedia</th>
              <th className={thClass + " text-right"} style={{ color: "#fb923c" }}>Tersedia Nominal</th>
              <th className={thClass + " text-right"} style={{ color: "#fb923c" }}>Pengeluaran</th>
              <th className={thClass + " text-right"} style={{ color: "#fb923c" }}>Pengeluaran Nominal</th>
              <th className={thClass + " text-right"} style={{ color: "#fb923c" }}>Transit In</th>
              <th className={thClass + " text-right"} style={{ color: "#fb923c" }}>Transit Out</th>
              <th className={thClass + " text-right"} style={{ color: "#fb923c" }}>Saldo Akhir</th>
              <th className={thClass + " text-right"} style={{ color: "#fb923c" }}>Saldo Akhir Nominal</th>
              <th className={thClass + " text-center"} style={{ color: "#fb923c" }}>Status</th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan={18} className="text-center py-12 text-gray-400">
                  Memuat data...
                </td>
              </tr>
            ) : formattedData.length === 0 ? (
              <tr>
                <td colSpan={18} className="text-center py-12 text-gray-400">
                  Tidak ada data untuk ditampilkan
                </td>
              </tr>
            ) : (
              formattedData.map((row) => {
                const status = getStockStatus(row.SaldoAkhir, row.MinQty);
                const penerimaanVal = parseFloat(row.Penerimaan) || 0;
                const pengeluaranVal = parseFloat(row.Pengeluaraan) || 0;
                const tersedia = (parseFloat(row.SaldoAkhir) || 0) - (parseFloat(row.MinQty) || 0);
                const tersediaNominal = (parseFloat(row.SaldoAwalNominal) || 0) + (parseFloat(row.PenerimaanNominal) || 0);
                const penerimaanClickable = penerimaanVal > 0 && !showAll;
                const pengeluaranClickable = pengeluaranVal > 0 && !showAll;
                const belumVal = parseFloat(row.QtyBelumDiterima) || 0;
                const belumClickable = belumVal > 0;
                const outVal = parseFloat(row.QtyTransitOut) || 0;
                const outClickable = outVal > 0;

                return (
                  <tr
                    key={row.BarangID + row.no}
                    className="hover:bg-gray-50 cursor-pointer"
                    onClick={() => onDetail && onDetail(row)}
                  >
                    <td className={tdClass + " text-gray-500 text-xs"}>{row.no}</td>
                    <td className={tdClass + " font-mono text-xs"}>{row.BarangID || "-"}</td>
                    <td className={tdClass + " font-mono text-xs"}>{row.KodeStockOpname || "-"}</td>
                    <td className={tdClass}>{row.NamaBarang || "-"}</td>
                    <td className={tdClass + " text-center"}>{row.NamaSatuan || "-"}</td>
                    <td className={tdClass + " text-right"}>{(row.MinQty || 0).toLocaleString()}</td>
                    <td className={tdClass + " text-right"}>{(row.SaldoAwal || 0).toLocaleString()}</td>
                    <td className={tdClass + " text-right"}>{(row.SaldoAwalNominal || 0).toLocaleString()}</td>
                    <td className={tdClass + " text-right"}>
                      <span
                        onClick={penerimaanClickable ? (e) => handlePenerimaanClick(e, row) : undefined}
                        style={{
                          cursor: penerimaanClickable ? "pointer" : "default",
                          textDecoration: penerimaanClickable ? "underline" : "none",
                          fontWeight: penerimaanClickable ? "600" : "normal",
                          color: penerimaanClickable ? "#2563eb" : "inherit",
                        }}
                        title={penerimaanClickable ? "Klik untuk lihat detail penerimaan" : ""}
                      >
                        {penerimaanVal.toLocaleString()}
                      </span>
                    </td>
                    <td className={tdClass + " text-right"}>{(row.PenerimaanNominal || 0).toLocaleString()}</td>
                    <td className={tdClass + " text-right"}>{tersedia.toLocaleString()}</td>
                    <td className={tdClass + " text-right"}>{tersediaNominal.toLocaleString()}</td>
                    <td className={tdClass + " text-right"}>
                      <span
                        onClick={pengeluaranClickable ? (e) => handlePengeluaranClick(e, row) : undefined}
                        style={{
                          color: "#dc2626",
                          cursor: pengeluaranClickable ? "pointer" : "default",
                          textDecoration: pengeluaranClickable ? "underline" : "none",
                          fontWeight: pengeluaranClickable ? "600" : "normal",
                        }}
                        title={pengeluaranClickable ? "Klik untuk lihat detail pengeluaran" : ""}
                      >
                        {pengeluaranVal.toLocaleString()}
                      </span>
                    </td>
                    <td className={tdClass + " text-right"} style={{ color: "#dc2626" }}>
                      {(parseFloat(row.PengeluaraanNominal) || 0).toLocaleString()}
                    </td>
                    <td className={tdClass + " text-right"}>
                      <span
                        onClick={belumClickable ? (e) => handleBelumDiterimaClick(e, row) : undefined}
                        style={{
                          color: belumVal > 0 ? "#d97706" : "inherit",
                          cursor: belumClickable ? "pointer" : "default",
                          textDecoration: belumClickable ? "underline" : "none",
                          fontWeight: belumClickable ? "600" : "normal",
                        }}
                        title={belumClickable ? "Transit In — klik untuk lihat PO yang belum diterima" : ""}
                      >
                        {belumVal.toLocaleString()}
                      </span>
                    </td>
                    <td className={tdClass + " text-right"}>
                      <span
                        onClick={outClickable ? (e) => handleTransitOutClick(e, row) : undefined}
                        style={{
                          color: outVal > 0 ? "#7c3aed" : "inherit",
                          cursor: outClickable ? "pointer" : "default",
                          textDecoration: outClickable ? "underline" : "none",
                          fontWeight: outClickable ? "600" : "normal",
                        }}
                        title={outClickable ? "Transit Out — klik untuk lihat pengeluaran yang belum di-Approve" : ""}
                      >
                        {outVal.toLocaleString()}
                      </span>
                    </td>
                    <td
                      className={tdClass + " text-right font-semibold"}
                      style={{ color: status.status === "danger" ? "#dc2626" : "#16a34a" }}
                    >
                      <span
                        onClick={(e) => handleSaldoAkhirClick(e, row)}
                        style={{ cursor: "pointer", textDecoration: "underline" }}
                        title="Klik untuk lihat komposisi Saldo Akhir"
                      >
                        {saldoAkhirTampil(row).toLocaleString()}
                      </span>
                    </td>
                    <td className={tdClass + " text-right"}>{(row.SaldoAkhirNominal || 0).toLocaleString()}</td>
                    <td className={tdClass + " text-center"}>
                      <span
                        className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium ${
                          status.status === "danger"
                            ? "bg-red-100 text-red-700"
                            : "bg-green-100 text-green-700"
                        }`}
                      >
                        <span
                          className={`w-1.5 h-1.5 rounded-full ${
                            status.status === "danger" ? "bg-red-500" : "bg-green-500"
                          }`}
                        />
                        {status.text}
                      </span>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {!isLoading && totalRows > 0 && (
        <div className="flex flex-col sm:flex-row justify-between items-center gap-3 mt-4 pt-3 border-t border-gray-200 text-sm text-gray-600">
          <div className="flex items-center gap-2">
            <span>Tampilkan</span>
            <select
              value={perPage}
              onChange={(e) => onPerRowsChange?.(Number(e.target.value), 1)}
              className="border border-gray-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              {rowOptions.map((n) => (
                <option key={n} value={n}>{n === -1 ? "Semua" : n}</option>
              ))}
            </select>
            <span>
              dari <strong>{totalRows}</strong> data
            </span>
          </div>

          <div className="flex items-center gap-1">
            <button
              onClick={() => onPageChange?.(currentPage - 1)}
              disabled={currentPage <= 1}
              className="p-1.5 rounded border border-gray-300 hover:bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed"
            >
              <BiChevronLeft className="text-lg" />
            </button>
            <span className="px-3 py-1 text-sm">
              Hal {currentPage} / {totalPages}
            </span>
            <button
              onClick={() => onPageChange?.(currentPage + 1)}
              disabled={currentPage >= totalPages}
              className="p-1.5 rounded border border-gray-300 hover:bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed"
            >
              <BiChevronRight className="text-lg" />
            </button>
          </div>
        </div>
      )}

      {/* Modal Detail Pengeluaran */}
      {modalOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          onClick={() => setModalOpen(false)}
        >
          <div
            className="bg-white rounded-lg shadow-xl w-full max-w-3xl mx-4 overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between px-6 py-4 border-b bg-red-50">
              <div>
                <h3 className="text-base font-semibold text-gray-800">Detail Pengeluaran Barang</h3>
                <p className="text-sm text-gray-500 mt-0.5">{modalBarang.BarangID} — {modalBarang.NamaBarang}</p>
                <p className="text-xs text-gray-400">
                  Periode: Bulan {periode?.bulan} / {periode?.tahun} &nbsp;|&nbsp; Bisnis Unit: {bisnisUnit}
                </p>
              </div>
              <button onClick={() => setModalOpen(false)} className="text-gray-400 hover:text-gray-600 text-2xl leading-none">&times;</button>
            </div>

            <div className="px-6 py-4 overflow-y-auto" style={{ maxHeight: "60vh" }}>
              {modalLoading ? (
                <div className="flex justify-center items-center py-12">
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-red-500"></div>
                  <span className="ml-3 text-gray-500">Memuat data...</span>
                </div>
              ) : modalData.length === 0 ? (
                <div className="text-center py-12 text-gray-400">Tidak ada data pengeluaran ditemukan.</div>
              ) : (
                <table className="w-full text-sm border-collapse">
                  <thead>
                    <tr style={{ backgroundColor: "#1e3a5f" }}>
                      {["No", "No. GE", "Tanggal", "Departemen", "Activity", "Status", "Qty Keluar"].map((h) => (
                        <th key={h} className="text-left px-3 py-2 border border-blue-900 font-semibold" style={{ color: "#fb923c" }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {modalData.map((d, i) => (
                      <tr key={i} className={i % 2 === 0 ? "bg-white" : "bg-gray-50"}>
                        <td className="px-3 py-2 border border-gray-200">{i + 1}</td>
                        <td className="px-3 py-2 border border-gray-200 font-mono text-xs">{d.GoodsExpenditureID}</td>
                        <td className="px-3 py-2 border border-gray-200 whitespace-nowrap">
                          {new Date(d.Tanggal).toLocaleDateString("id-ID", { day: "2-digit", month: "short", year: "numeric" })}
                        </td>
                        <td className="px-3 py-2 border border-gray-200">{d.Departemen || "-"}</td>
                        <td className="px-3 py-2 border border-gray-200">{d.NamaActivity || d.ActivityID || "-"}</td>
                        <td className="px-3 py-2 border border-gray-200">
                          <span className={`px-2 py-0.5 rounded text-xs font-medium ${d.Status === "Approved" ? "bg-green-100 text-green-700" : d.Status === "Ditolak" ? "bg-red-100 text-red-700" : "bg-yellow-100 text-yellow-700"}`}>
                            {d.Status}
                          </span>
                        </td>
                        <td className="px-3 py-2 border border-gray-200 text-right font-semibold text-red-600">
                          {(parseFloat(d.QtyKeluar) || 0).toLocaleString()}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr className="bg-gray-100 font-semibold">
                      <td colSpan={6} className="px-3 py-2 border border-gray-200 text-right">Total Pengeluaran</td>
                      <td className="px-3 py-2 border border-gray-200 text-right text-red-600">{totalQtyKeluar.toLocaleString()}</td>
                    </tr>
                  </tfoot>
                </table>
              )}
            </div>

            <div className="px-6 py-3 border-t flex justify-end bg-gray-50">
              <button onClick={() => setModalOpen(false)} className="flex items-center gap-1 bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow text-sm">Tutup</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Detail Penerimaan */}
      {penerimaanModalOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          onClick={() => setPenerimaanModalOpen(false)}
        >
          <div
            className="bg-white rounded-lg shadow-xl w-full max-w-4xl mx-4 overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between px-6 py-4 border-b bg-blue-50">
              <div>
                <h3 className="text-base font-semibold text-gray-800">Detail Penerimaan Barang</h3>
                <p className="text-sm text-gray-500 mt-0.5">{penerimaanModalBarang.BarangID} — {penerimaanModalBarang.NamaBarang}</p>
                <p className="text-xs text-gray-400">
                  Periode: Bulan {periode?.bulan} / {periode?.tahun} &nbsp;|&nbsp; Bisnis Unit: {bisnisUnit}
                </p>
              </div>
              <button onClick={() => setPenerimaanModalOpen(false)} className="text-gray-400 hover:text-gray-600 text-2xl leading-none">&times;</button>
            </div>

            <div className="px-6 py-4 overflow-y-auto" style={{ maxHeight: "60vh" }}>
              {penerimaanModalLoading ? (
                <div className="flex justify-center items-center py-12">
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
                  <span className="ml-3 text-gray-500">Memuat data...</span>
                </div>
              ) : penerimaanModalData.length === 0 ? (
                <div className="text-center py-12 text-gray-400">Tidak ada data penerimaan ditemukan.</div>
              ) : (
                <table className="w-full text-sm border-collapse">
                  <thead>
                    <tr style={{ backgroundColor: "#1e3a5f" }}>
                      {["No", "No. GA", "No. PO", "Tanggal", "Supplier", "Lokasi Gudang", "Qty PO", "Qty Terima"].map((h) => (
                        <th key={h} className="text-left px-3 py-2 border border-blue-900 font-semibold" style={{ color: "#fb923c" }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {penerimaanModalData.map((d, i) => (
                      <tr key={i} className={i % 2 === 0 ? "bg-white" : "bg-gray-50"}>
                        <td className="px-3 py-2 border border-gray-200">{i + 1}</td>
                        <td className="px-3 py-2 border border-gray-200 font-mono text-xs">{d.GoodsAcceptanceID}</td>
                        <td className="px-3 py-2 border border-gray-200 font-mono text-xs">{d.PurchaseOrderID}</td>
                        <td className="px-3 py-2 border border-gray-200 whitespace-nowrap">
                          {new Date(d.Tanggal).toLocaleDateString("id-ID", { day: "2-digit", month: "short", year: "numeric" })}
                        </td>
                        <td className="px-3 py-2 border border-gray-200">{d.NamaSupplier || "-"}</td>
                        <td className="px-3 py-2 border border-gray-200">{d.LokasiGudang || "-"}</td>
                        <td className="px-3 py-2 border border-gray-200 text-right">{(parseFloat(d.QtyPO) || 0).toLocaleString()}</td>
                        <td className="px-3 py-2 border border-gray-200 text-right font-semibold text-blue-600">{(parseFloat(d.QtyTerima) || 0).toLocaleString()}</td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr className="bg-gray-100 font-semibold">
                      <td colSpan={7} className="px-3 py-2 border border-gray-200 text-right">Total Qty Terima</td>
                      <td className="px-3 py-2 border border-gray-200 text-right text-blue-600">
                        {penerimaanModalData.reduce((sum, d) => sum + (parseFloat(d.QtyTerima) || 0), 0).toLocaleString()}
                      </td>
                    </tr>
                  </tfoot>
                </table>
              )}
            </div>

            <div className="px-6 py-3 border-t flex justify-end bg-gray-50">
              <button onClick={() => setPenerimaanModalOpen(false)} className="flex items-center gap-1 bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow text-sm">Tutup</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Detail Belum Diterima */}
      {belumModalOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          onClick={() => setBelumModalOpen(false)}
        >
          <div
            className="bg-white rounded-lg shadow-xl w-full max-w-4xl mx-4 overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between px-6 py-4 border-b bg-amber-50">
              <div>
                <h3 className="text-base font-semibold text-gray-800">Detail Transit In (Barang Belum Diterima)</h3>
                <p className="text-sm text-gray-500 mt-0.5">{belumModalBarang.BarangID} — {belumModalBarang.NamaBarang}</p>
                <p className="text-xs text-gray-400">
                  {showAll ? "Posisi terkini" : `Posisi akhir periode: Bulan ${periode?.bulan} / ${periode?.tahun}`} &nbsp;|&nbsp; Bisnis Unit: {bisnisUnit}
                </p>
              </div>
              <button onClick={() => setBelumModalOpen(false)} className="text-gray-400 hover:text-gray-600 text-2xl leading-none">&times;</button>
            </div>

            <div className="px-6 py-4 overflow-y-auto" style={{ maxHeight: "60vh" }}>
              {belumModalLoading ? (
                <div className="flex justify-center items-center py-12">
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-amber-500"></div>
                  <span className="ml-3 text-gray-500">Memuat data...</span>
                </div>
              ) : belumModalData.length === 0 ? (
                <div className="text-center py-12 text-gray-400">Tidak ada PO yang belum diterima (Transit In).</div>
              ) : (
                <table className="w-full text-sm border-collapse">
                  <thead>
                    <tr style={{ backgroundColor: "#1e3a5f" }}>
                      {["No", "No. PO", "Tanggal PO", "Supplier", "Qty PO", "Sudah Diterima", "Belum Diterima"].map((h) => (
                        <th key={h} className="text-left px-3 py-2 border border-blue-900 font-semibold" style={{ color: "#fb923c" }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {belumModalData.map((d, i) => (
                      <tr key={i} className={i % 2 === 0 ? "bg-white" : "bg-gray-50"}>
                        <td className="px-3 py-2 border border-gray-200">{i + 1}</td>
                        <td className="px-3 py-2 border border-gray-200 font-mono text-xs">{d.PurchaseOrderID}</td>
                        <td className="px-3 py-2 border border-gray-200 whitespace-nowrap">
                          {new Date(d.TanggalPO).toLocaleDateString("id-ID", { day: "2-digit", month: "short", year: "numeric" })}
                        </td>
                        <td className="px-3 py-2 border border-gray-200">{d.NamaSupplier || "-"}</td>
                        <td className="px-3 py-2 border border-gray-200 text-right">{(parseFloat(d.QtyPO) || 0).toLocaleString()}</td>
                        <td className="px-3 py-2 border border-gray-200 text-right">{(parseFloat(d.QtyDiterima) || 0).toLocaleString()}</td>
                        <td className="px-3 py-2 border border-gray-200 text-right font-semibold text-amber-600">
                          {(parseFloat(d.QtySisa) || 0).toLocaleString()} {d.NamaSatuan}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr className="bg-gray-100 font-semibold">
                      <td colSpan={6} className="px-3 py-2 border border-gray-200 text-right">Total Transit In</td>
                      <td className="px-3 py-2 border border-gray-200 text-right text-amber-600">
                        {belumModalData.reduce((sum, d) => sum + (parseFloat(d.QtySisa) || 0), 0).toLocaleString()}
                      </td>
                    </tr>
                  </tfoot>
                </table>
              )}
            </div>

            <div className="px-6 py-3 border-t flex justify-end bg-gray-50">
              <button onClick={() => setBelumModalOpen(false)} className="flex items-center gap-1 bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow text-sm">Tutup</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Detail Transit Out */}
      {outModalOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          onClick={() => setOutModalOpen(false)}
        >
          <div className="bg-white rounded-lg shadow-xl w-full max-w-3xl mx-4 overflow-hidden" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between px-6 py-4 border-b bg-purple-50">
              <div>
                <h3 className="text-base font-semibold text-gray-800">Detail Transit Out (Pengeluaran Belum Di-Approve)</h3>
                <p className="text-sm text-gray-500 mt-0.5">{outModalBarang.BarangID} — {outModalBarang.NamaBarang}</p>
                <p className="text-xs text-gray-400">
                  Stok sudah terpotong saat dikirim ke approval, belum final &nbsp;|&nbsp; Bisnis Unit: {bisnisUnit}
                </p>
              </div>
              <button onClick={() => setOutModalOpen(false)} className="text-gray-400 hover:text-gray-600 text-2xl leading-none">&times;</button>
            </div>
            <div className="px-6 py-4 overflow-y-auto" style={{ maxHeight: "60vh" }}>
              {outModalLoading ? (
                <div className="flex justify-center items-center py-12">
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-500"></div>
                  <span className="ml-3 text-gray-500">Memuat data...</span>
                </div>
              ) : outModalData.length === 0 ? (
                <div className="text-center py-12 text-gray-400">Tidak ada pengeluaran yang menunggu approval.</div>
              ) : (
                <TransitOutTable data={outModalData} />
              )}
            </div>
            <div className="px-6 py-3 border-t flex justify-end bg-gray-50">
              <button onClick={() => setOutModalOpen(false)} className="flex items-center gap-1 bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow text-sm">Tutup</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Komposisi Saldo Akhir */}
      {saldoModalOpen && saldoModalRow && (() => {
        const r = saldoModalRow;
        const f = (v) => (parseFloat(v) || 0).toLocaleString();
        const out = parseFloat(r.QtyTransitOut) || 0;
        const baris = (label, nilai, opts = {}) => (
          <tr className={opts.total ? "bg-gray-100 font-semibold" : ""}>
            <td className="px-3 py-2 border border-gray-200">{opts.sign && <span className="inline-block w-5 text-gray-400">{opts.sign}</span>}{label}</td>
            <td className="px-3 py-2 border border-gray-200 text-right" style={opts.color ? { color: opts.color } : undefined}>{nilai}</td>
          </tr>
        );
        return (
          <div
            className="fixed inset-0 z-50 flex items-center justify-center"
            style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
            onClick={() => setSaldoModalOpen(false)}
          >
            <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl mx-4 overflow-hidden" onClick={(e) => e.stopPropagation()}>
              <div className="flex items-center justify-between px-6 py-4 border-b bg-green-50">
                <div>
                  <h3 className="text-base font-semibold text-gray-800">Komposisi Saldo Akhir</h3>
                  <p className="text-sm text-gray-500 mt-0.5">{r.BarangID} — {r.NamaBarang}</p>
                  <p className="text-xs text-gray-400">
                    {showAll ? "Periode terkini" : `Periode: Bulan ${periode?.bulan} / ${periode?.tahun}`} &nbsp;|&nbsp; Bisnis Unit: {bisnisUnit} &nbsp;|&nbsp; Satuan: {r.NamaSatuan || "-"}
                  </p>
                </div>
                <button onClick={() => setSaldoModalOpen(false)} className="text-gray-400 hover:text-gray-600 text-2xl leading-none">&times;</button>
              </div>
              <div className="px-6 py-4 overflow-y-auto" style={{ maxHeight: "65vh" }}>
                <table className="w-full text-sm border-collapse">
                  <tbody>
                    {baris("Saldo Awal", f(r.SaldoAwal))}
                    {baris("Penerimaan", f(r.Penerimaan), { sign: "+", color: "#2563eb" })}
                    {baris("Pengeluaran", f(r.Pengeluaraan), { sign: "−", color: "#dc2626" })}
                    {baris("Saldo Akhir pembukuan", f(r.SaldoAkhir), { total: true })}
                    {baris("Transit Out (pengeluaran belum di-Approve)", f(out), { sign: "+", color: "#7c3aed" })}
                    {baris("Saldo Akhir", saldoAkhirTampil(r).toLocaleString(), { total: true })}
                  </tbody>
                </table>
                <p className="text-xs text-gray-500 mt-2">
                  Transit Out sudah ikut terhitung di Pengeluaran (stok terpotong saat dikirim ke approval), lalu
                  ditambahkan kembali karena belum di-Approve. Transit In (barang belum diterima): {f(r.QtyBelumDiterima)} — tidak termasuk Saldo Akhir.
                </p>
                {out > 0 && (
                  <div className="mt-4">
                    <div className="text-sm font-semibold text-gray-700 mb-2">Rincian Transit Out</div>
                    {saldoModalLoading ? (
                      <div className="text-center py-6 text-gray-400">Memuat data...</div>
                    ) : saldoModalData.length === 0 ? (
                      <div className="text-center py-4 text-gray-400">Rincian tidak ditemukan.</div>
                    ) : (
                      <TransitOutTable data={saldoModalData} />
                    )}
                  </div>
                )}
              </div>
              <div className="px-6 py-3 border-t flex justify-end bg-gray-50">
                <button onClick={() => setSaldoModalOpen(false)} className="flex items-center gap-1 bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow text-sm">Tutup</button>
              </div>
            </div>
          </div>
        );
      })()}
    </div>
  );
};

// Tabel rincian GE yang menunggu approval (dipakai popup Transit Out & komposisi Saldo Akhir).
const TransitOutTable = ({ data }) => (
  <table className="w-full text-sm border-collapse">
    <thead>
      <tr style={{ backgroundColor: "#1e3a5f" }}>
        {["No", "No. Pengeluaran", "Tanggal", "Peminta", "Keterangan", "Qty"].map((h) => (
          <th key={h} className="text-left px-3 py-2 border border-blue-900 font-semibold" style={{ color: "#fb923c" }}>{h}</th>
        ))}
      </tr>
    </thead>
    <tbody>
      {data.map((d, i) => (
        <tr key={i} className={i % 2 === 0 ? "bg-white" : "bg-gray-50"}>
          <td className="px-3 py-2 border border-gray-200">{i + 1}</td>
          <td className="px-3 py-2 border border-gray-200 font-mono text-xs">{d.GoodsExpenditureID}</td>
          <td className="px-3 py-2 border border-gray-200 whitespace-nowrap">
            {new Date(d.Tanggal).toLocaleDateString("id-ID", { day: "2-digit", month: "short", year: "numeric" })}
          </td>
          <td className="px-3 py-2 border border-gray-200">{d.NamaPeminta || "-"}</td>
          <td className="px-3 py-2 border border-gray-200">{d.Keterangan || "-"}</td>
          <td className="px-3 py-2 border border-gray-200 text-right font-semibold text-purple-600">
            {(parseFloat(d.QtyKeluar) || 0).toLocaleString()} {d.NamaSatuan}
          </td>
        </tr>
      ))}
    </tbody>
    <tfoot>
      <tr className="bg-gray-100 font-semibold">
        <td colSpan={5} className="px-3 py-2 border border-gray-200 text-right">Total Transit Out</td>
        <td className="px-3 py-2 border border-gray-200 text-right text-purple-600">
          {data.reduce((sum, d) => sum + (parseFloat(d.QtyKeluar) || 0), 0).toLocaleString()}
        </td>
      </tr>
    </tfoot>
  </table>
);

export default TableStock;
